<template src="./scanQR-BigBangBoom.html"></template>
<!-- <template src="./scanQR-socoBeautyStar.html"></template> -->

<script>
import QrcodeVue from 'qrcode.vue';
import SocketIO from 'socket.io-client';
import helpers from '@/mixins/helpers';
import autotimeout from '@/mixins/auto-timeout';
import connectionHelper from '@/mixins/connection-helper.js';

const QR_CODE_LIFE_TIME = 10 * 60 * 1000;
// const GET_TOKEN_INTERVAL = 5 * 1000;

const Config = require('~/config/default.env').default;

const socket = SocketIO(`${Config.MS_SOCKET_API_URL}/store`, { transports: ['websocket'] });

export default {
  name: 'home',
  components: {
    QrcodeVue,
  },
  mixins: [helpers, autotimeout, connectionHelper],
  data() {
    return {
      quotes: null,
      qrGenTimer: null,
      getTokenTimer: null,
    };
  },
  computed: {
    is_development() {
      return Config.NODE_ENV === 'development';
    },
    QRcode() {
      const QRCodeValue = this.$store.state.QRcode.value || '';
      return QRCodeValue;

      // if (this.is_development) {
      //   return 'https://sociolla.test-app.link?action=login&value=' + QRCodeValue;
      // }

      // return 'https://sociolla.app.link?action=login&value=' + QRCodeValue;
    },
    nextUrl() {
      return '/soco-vending-machine-event/bbb-landing';
    },
    beautyATMData() {
      return this.$store.state.beautyAtmData || null;
    },
  },
  async created() {
    Cookies.set('token', '', { expires: 0 });

    const isFromVmCola = this.$route.query && this.$route.query.vmcola === 'true';
    await this.$store.dispatch('getBeautyAtmData', {
      isFromVendingMachine: !isFromVmCola,
      isFromVmCola,
    });
    let is_active_in_offline_store = true;

    if (this.beautyATMData && 'is_active_in_offline_store' in this.beautyATMData) {
      is_active_in_offline_store = Boolean(this.beautyATMData.is_active_in_offline_store);

      if (!is_active_in_offline_store) {
        return;
      }
    }

    this.$store.dispatch('generateQrCode');
    socket.emit('join', this.$store.state.QRcode.value);

    // re-generate qr code every 10 minutes
    this.qrGenTimer = setInterval(() => {
      if (this.$store.state.QRcode.isLoggedIn) {
        // stop re-generation after logging in
        return clearInterval(this.qrGenTimer);
      }
      this.$store.dispatch('generateQrCode');
      socket.emit('join', this.$store.state.QRcode.value);
    }, QR_CODE_LIFE_TIME);

    const self = this;

    socket.on('qr_code_login', function (data) {
      if (self.$store.state.QRcode.value == data.qr_code) {
        Cookies.set('token', data.token, { expires: 1 });
        self.$store.commit('authToken', data.token);
        self.$store.dispatch('getToken', { redirect: self.nextUrl, data: self, is_soco_vending_machine_event: true });
        socket.off('qr_code_login');
      }
    });
    this.initOfflineListener({
      pathOffline: 'offline',
      context: this,
    });
  },

  destroyed() {
    clearInterval(this.qrGenTimer);
    this.destroyListener();
  },
};
</script>

<style lang="scss" scoped>
@import 'scanQR';
.bbb-qr {
  background: #000 url('/static/img/big-bang-boom/bg-bbb-store.png') no-repeat center center;
  background-size: cover;
  min-height: calc(100vh - 161px);
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border;
  padding: 0;
  text-align: center;
}
.title {
  margin: 0 auto 100px;
  display: block;
}
.scanqr-logo {
  position: relative;
  top: -230px;
}
.teaser {
  margin: 0 auto 24px;
  display: block;
}
.scan-qr-machines {
  width: 320px;
  height: 380px;
  background: #fff;
  box-shadow: 3px 12px 12px rgba(48, 0, 10, 0.5);
  border-radius: 7px;
  margin: 0 auto 100px;
  font: normal 30px/42px 'lato-bold', sans-serif;
  letter-spacing: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.scan-qr-machines img {
  margin: 0 auto;
}
.scan-qr-machines img.arrow {
  position: relative;
  top: -3px;
}
.back {
  font: normal 48px 'lato-bold', sans-serif;
  color: #fff;
  margin: 24px 0 0;
  border-bottom: solid 2px #fff;
}
.scan-wait {
  font: normal 25px/35px 'lato-bold', sans-serif;
  color: #b32656;
  letter-spacing: 2.5px;
  padding: 24px 0 0;
}
.scan-footers {
  padding: 55px 0;
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
}
.scan-footers p {
  font-family: 'lato-bold', sans-serif;
  font-size: 36px;
  color: #fff;
  text-align: center;
  margin-bottom: 0;
  text-transform: uppercase;
  letter-spacing: 2px;
}
</style>
